import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useResolvedPath } from "react-router-dom";
import { useAppSelector } from "src/store/actions/action";
import { setNoticeDataInit, setNoticeRegister } from "src/store/reducers/noticeReduce";
import { toInteger } from "lodash";
import "moment/locale/ko";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import Select from "src/components/common/Select";
import TextInput from "src/components/common/TextInput";
import List from "src/components/common/List";
import WriteOptionItem from "src/components/notice/WriteOptionItem";
import styled from "styled-components";
import FileUpload from "src/components/common/FileUpload";
import {
  useAddNoticeMutation,
  useGetS3UrlMutation,
  useGetNoticeMutation,
  useModifyNoticeMutation,
  useChangeStoresMutation,
  useGetImportantNoticeCountQuery,
} from "../../api/noticeAPI";
import { RotatingLines } from "react-loader-spinner";
import InputFileV2 from "../../components/common/InputFileV2";
import { useParams } from "react-router-dom";
import { setModifyDataInit, setModifyRegister } from "../../store/reducers/modifyReduce";
import { category, noticeInitData } from "../../constants/notice";
import { setToggleData } from "../../store/reducers/toggleReduce";
import { checkDeleteImage } from "../../utils/noticeUtil";
import { canReuseAttachUploadState, noticeAttachKey, uploadNoticeAttachments } from "../../utils/noticeAttachUpload";
import moment from "moment/moment";

import "../../styles/custom-toastui-editor.css";
import { Editor } from "@toast-ui/react-editor";
// Toast ColorSyntax 플러그인
import "tui-color-picker/dist/tui-color-picker.css";
import "@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css";
import colorSyntax from "@toast-ui/editor-plugin-color-syntax";

// uploadAttachments 가 이미 구체적인 실패 사유를 화면에 알린 경우를 가리킨다. 아래 catch
// 가 일반 문구로 덮어써 어느 파일에서 멈췄는지를 지우지 않도록 구분한다.
const ATTACH_REPORTED = "[ATTACH_REPORTED]";

function noticeRegister() {
  const param = useParams();
  const [getNotice] = useGetNoticeMutation();
  const [modifyMode, setModifyMode] = useState(false);
  const modifyReduxData = useAppSelector((state) => state.modifyReduce);
  const [modifyNotice] = useModifyNoticeMutation();
  const [getS3Urls] = useGetS3UrlMutation();
  const [addNotice] = useAddNoticeMutation();
  const [changeStores] = useChangeStoresMutation();
  const navigate = useNavigate();
  const noticeData = useAppSelector((state) => state.noticeReduce);
  const dispatch = useDispatch();
  const [currentCategory, setCurrentCategory] = useState(noticeData.currentCategory ? noticeData.currentCategory : 1301000);
  const [title, setTitle] = useState(noticeData.title ? noticeData.title : "");
  const [contents, setContents] = useState(noticeData.contents ? noticeData.contents : "");
  const [isSelectedStore, setIsSelectedStore] = useState(noticeData.stores !== undefined && noticeData.stores?.length > 0 ? true : false);
  const [hasEndDate, setHasEndDate] = useState(noticeData.dateToggle ? true : false);
  const [sending, setSending] = useState(false);
  const [imageList, setImageList] = useState<(File | Image)[]>(noticeData.imageList ? noticeData.imageList : []);
  const currentSendMode = useAppSelector((state) => state.toogleReduce);
  const getImportNotiCount = useGetImportantNoticeCountQuery({});

  const editorRef = useRef<Editor>(null);

  useEffect(() => {
    dispatch(setNoticeRegister({ beforeStores: [] }));
  }, []);

  function handleChange(e: any) {
    const editorContents = editorRef.current?.getInstance().getHTML();
    editorContents && setContents(editorContents);
  }

  async function getNoticeData(idx: string) {
    const response: any = await getNotice(idx);
    const temp: ModifyNotice = await response.data;
    console.log("@@@@", temp.min_image_count);
    const modifyTempData: NoticeRegisterType = {
      currentCategory: parseInt(temp.cate_idx),
      title: temp.title,
      contents: temp.contents,
      stores: temp.execute_stores.map((store: { store_id: string }) => store.store_id),
      dateToggle: temp.end_date ? true : false,
      endDate: temp.end_date,
      importNotice: temp.important_yn == "Y" ? true : false,
      fileList: temp.attachments,
      imageList: temp.images,
      limitImage: temp.min_image_count,
    };
    dispatch(setModifyRegister(modifyTempData));
    dispatch(setModifyRegister({ needModifyData: false }));
  }

  useEffect(() => {
    if (noticeData.dateToggle !== undefined) {
      setHasEndDate(noticeData.dateToggle);
    }
  }, [noticeData.dateToggle]);

  useEffect(() => {
    if (modifyMode) {
      modifyReduxData.title !== undefined && setTitle(modifyReduxData.title);
      modifyReduxData.contents !== undefined && editorRef.current?.getInstance().setHTML(modifyReduxData.contents);
      modifyReduxData.imageList !== undefined && setImageList(modifyReduxData.imageList);
      modifyReduxData.endDate !== "" && dispatch(setNoticeRegister({ endDate: moment(modifyReduxData.endDate).format("YYYY.MM.DD") }));
      modifyReduxData.dateToggle !== undefined && dispatch(setNoticeRegister({ dateToggle: modifyReduxData.dateToggle }));
      modifyReduxData.importNotice !== undefined && dispatch(setNoticeRegister({ importNotice: modifyReduxData.importNotice }));
      modifyReduxData.stores !== undefined && dispatch(setNoticeRegister({ stores: modifyReduxData.stores }));
      modifyReduxData.currentCategory !== undefined && setCurrentCategory(modifyReduxData.currentCategory);
      modifyReduxData.fileList !== undefined && dispatch(setNoticeRegister({ fileList: modifyReduxData.fileList }));
      modifyReduxData.limitImage !== undefined && dispatch(setNoticeRegister({ limitImage: modifyReduxData.limitImage }));
    }
  }, [modifyReduxData]);

  useEffect(() => {
    if (param.notice_idx) {
      setModifyMode(true);
      modifyReduxData.needModifyData && getNoticeData(param.notice_idx);
    }
  }, [param.notice_idx]);

  useEffect(() => {
    dispatch(setNoticeRegister({ imageList: imageList }));
  }, [imageList]);

  //title,category,contents 변경시 리덕스 변경.
  useEffect(() => {
    try {
      dispatch(setNoticeRegister({ currentCategory: currentCategory, title: title, contents: contents }));
    } catch (e) {
      console.error(e);
    }
  }, [currentCategory, title, contents]);

  //카테고리 선택시 state변경
  function onCategoryChange(e: React.ChangeEvent<HTMLSelectElement>) {
    setCurrentCategory(toInteger(e.target.value));
  }

  //S3Url을 받아온다.
  async function getS3Url(fileList: (File | Attachments)[]) {
    let result: S3Data[] = [];
    if ((fileList[0] as File).name) {
      const dataList: { originalFileName: string; contentType: string; size: number }[] = [];
      fileList.forEach((file) => {
        dataList.push({ originalFileName: (file as File).name, contentType: (file as File).type, size: (file as File).size });
      });
      const response: any = await getS3Urls({ data: dataList });
      result = await response.data.data;
    }
    return result;
  }

  // 첨부 업로드 상태. 같은 파일 묶음으로 다시 등록을 누르면 성공했던 파일은 건너뛰고
  // 남은 것만 올린다. presigned URL 유효시간이 10,000초이므로 URL 도 다시 쓸 수 있다.
  const attachUploadRef = useRef<{ key: string; urls: S3Data[]; uploaded: Set<number>; mintedAt: number } | null>(null);

  // 첨부를 올리고 S3 키 목록을 돌려준다. 실패하면 어느 파일에서 멈췄는지 화면에 알리고
  // null 을 돌려준다. 캠페인 1회분은 약 1GB 를 순차 전송하므로 진행률도 함께 알린다.
  async function uploadAttachments(files: (File | Attachments)[], sendingLabel: string) {
    const target = files as File[];
    const key = noticeAttachKey(target);
    const cached = attachUploadRef.current;
    // 묶음이 같고 발급이 오래되지 않았을 때만 재사용한다. 만료된 URL 을 계속 다시 쓰면
    // 재시도가 영구히 실패한다.
    const state =
      canReuseAttachUploadState(cached, key, target.length) && cached ? cached : { key, urls: await getS3Url(files), uploaded: new Set<number>(), mintedAt: Date.now() };
    attachUploadRef.current = state;
    const uploadResult = await uploadNoticeAttachments(target, state.urls, {
      uploaded: state.uploaded,
      onProgress: (done, total) => dispatch(setToggleData({ mode: "SENDING", data: `${sendingLabel} (${done}/${total})` })),
    });
    if (!uploadResult.ok) {
      dispatch(setToggleData({ mode: "ERROR", data: `${uploadResult.failedName} 업로드에 실패했습니다.\n다시 등록하시면 남은 파일만 이어서 올립니다.` }));
      return null;
    }
    return state.urls;
  }

  function checkImportNotice() {
    let result = true;
    getImportNotiCount.refetch();
    const importNoticeCount = getImportNotiCount.data.count;
    if (modifyReduxData.importNotice === false && noticeData.importNotice === true && importNoticeCount >= 5) {
      alert("중요공지 설정 가능 개수는 최대 5개입니다.\n다른 중요공지 해제 후 추가해주세요.");
      result = false;
    }
    return result;
  }
  async function register() {
    if (!checkBlank()) return;
    if (!checkImportNotice()) return;
    dispatch(setToggleData({ mode: "SENDING", data: "공지 등록 중입니다." }));
    setSending(true);
    const sendData: NoticeApi = {
      imageList: undefined,
      title: undefined,
      contents: undefined,
      currentCategory: undefined,
      endDate: undefined,
      important: undefined,
      s3UrlList: undefined,
      stores: undefined,
    };
    try {
      //FileList가 있으면 S3데이터 가져오기
      if (noticeData.fileList && noticeData.fileList.length > 0) {
        const s3Urls = await uploadAttachments(noticeData.fileList, "공지 등록 중입니다.");
        if (!s3Urls) throw ATTACH_REPORTED;
        sendData.s3UrlList = s3Urls;
      }
      sendData.imageList = noticeData.imageList;
      sendData.title = noticeData.title;
      sendData.contents = noticeData.contents;
      sendData.currentCategory = noticeData.currentCategory;
      sendData.endDate = noticeData.endDate;
      sendData.important = noticeData.importNotice;
      sendData.stores = noticeData.stores;
      sendData.limitImage = noticeData.limitImage;
      const result: any = await sendNotify(sendData);
      if (result.data.message === "success") {
        setSending(false);
        attachUploadRef.current = null;
        dispatch(setToggleData({ mode: "SUCCESS", data: "공지 등록 완료." }));
        back();
      } else {
        throw "[E03]";
      }
    } catch (err) {
      // uploadAttachments 가 이미 알린 실패는 그 문구를 남겨 둔다.
      if (err !== ATTACH_REPORTED) dispatch(setToggleData({ mode: "ERROR", data: "공지 등록 실패." }));
      setSending(false);
    }
  }
  function checkDeleteAttach(before?: (File | Attachments)[], after?: (File | Attachments)[]) {
    let result: string[] = [];
    if (before && after) {
      const beforeData = before.filter((temp) => (temp as Attachments).attachment_idx !== undefined);
      const afterData = after.filter((temp) => (temp as Attachments).attachment_idx !== undefined);
      const deleteAttachments = beforeData.filter((x) => !afterData.includes(x));
      result = deleteAttachments.map((attach) => (attach as Attachments).attachment_idx.toString());
    }
    return result;
  }

  function checkStores(before?: string[], after?: string[]) {
    let result: StoreChangeApi = { insert_stores: [], delete_stores: [] };
    if (before && after) {
      const insertStores = after.filter((store) => !before.includes(store));
      const deleteStores = before.filter((store) => !after.includes(store));

      const insertStoreToApi = insertStores.map((store) => ({ user_id: store }));
      const deleteStoreToApi = deleteStores.map((store) => ({ user_id: store }));
      result = { insert_stores: insertStoreToApi, delete_stores: deleteStoreToApi };
    }
    return result;
  }

  async function modifyRegister(idx: string) {
    if (!checkBlank()) return;
    if (!checkImportNotice()) return;
    dispatch(setToggleData({ mode: "SENDING", data: "공지 수정중입니다." }));
    setSending(true);
    const sendData: ModifyApi = {
      imageList: undefined,
      title: undefined,
      contents: undefined,
      currentCategory: undefined,
      endDate: undefined,
      important: undefined,
      s3UrlList: undefined,
      deleteImgs: undefined,
      deleteAttachments: undefined,
      limitImage: 0,
    };
    try {
      if (!idx) throw "[E01]";
      const addFileList = noticeData.fileList ? noticeData.fileList.filter((file) => (file as File).name !== undefined) : [];
      if (addFileList.length > 0) {
        const s3Urls = await uploadAttachments(addFileList, "공지 수정중입니다.");
        if (!s3Urls) throw ATTACH_REPORTED;
        sendData.s3UrlList = s3Urls;
      }

      if (JSON.stringify(noticeData.stores) != JSON.stringify(modifyReduxData.stores)) {
        const storeChangeApi = checkStores(modifyReduxData.stores, noticeData.stores);
        const resposnse: any = await changeStores({ noticeIdx: idx, data: storeChangeApi });
        if (resposnse?.data?.message !== "success") throw "[E04]";
      }
      const addImageList = noticeData.imageList ? noticeData.imageList.filter((image) => (image as File).name !== undefined) : [];
      sendData.imageList = addImageList;
      sendData.title = noticeData.title;
      sendData.contents = noticeData.contents;
      sendData.currentCategory = noticeData.currentCategory;
      sendData.endDate = noticeData.endDate;
      sendData.important = noticeData.importNotice;
      sendData.deleteAttachments = checkDeleteAttach(modifyReduxData.fileList, noticeData.fileList);
      sendData.deleteImgs = checkDeleteImage(modifyReduxData.imageList, noticeData.imageList);
      sendData.limitImage = noticeData.limitImage;
      const result: any = await sendModify(idx, sendData);
      if (result.data.message === "success") {
        setSending(false);
        attachUploadRef.current = null;
        dispatch(setToggleData({ mode: "SUCCESS", data: "공지 수정 완료." }));
        back();
      } else {
        throw "[E03]";
      }
    } catch (err) {
      // uploadAttachments 가 이미 알린 실패는 그 문구를 남겨 둔다.
      if (err !== ATTACH_REPORTED) dispatch(setToggleData({ mode: "ERROR", data: "공지 수정 실패." }));
      setSending(false);
    }
  }

  function back() {
    dispatch(() => {
      setModifyDataInit();
      setNoticeDataInit();
    });
    // dispatch(setNoticeDataInit());
    //수정 API(S3) 수정 후 -1을 통하여 /notice-register/XXXXXXXXXX 로 이동시 데이터 끊김.. 그래서 보내는 도중에는 notice-list로 바로 이동하게함.
    currentSendMode.mode != "IDLE" ? navigate("/notice-list/") : navigate(-1);
    // navigate("/notice-list", { replace: true });
  }

  function checkBlank() {
    let result = true;
    if (title == "") {
      alert("제목을 입력해 주세요");
      result = false;
    } else if (contents == "") {
      alert("내용을 입력해 주세요");
      result = false;
    } else if (isSelectedStore) {
      if (hasEndDate === false) {
        alert("마감일자를 등록해주세요. 이행매장이 있는 경우, 마감일자 등록은 필수입니다.");
        result = false;
      }
    } else {
      const charLength = editorRef.current
        ?.getInstance()
        .getHTML()
        .replace(/<[^>]*>?/g, "").length;
      if (charLength && charLength > 1000) {
        alert("내용은 1,000자를 초과할 수 없습니다.");
        result = false;
      }
    }
    return result;
  }

  async function sendNotify(input: NoticeApi) {
    const form = new FormData();
    input.imageList && input.imageList.forEach((image) => form.append("images", image as File));
    input.title && form.append("title", title);
    input.contents && form.append("contents", contents);
    input.currentCategory && form.append("cate_idx", input.currentCategory.toString());
    input.endDate && form.append("end_date", input.endDate);
    form.append("important_yn", input.important ? "Y" : "N");
    input.s3UrlList &&
      input.s3UrlList.forEach((url, index) => {
        form.append(`attachments[${index}][file_origin_name]`, url.originalFileName);
        form.append(`attachments[${index}][file_name]`, url.fileName);
        form.append(`attachments[${index}][file_url]`, url.path);
        form.append(`attachments[${index}][ext]`, url.ext);
        form.append(`attachments[${index}][size]`, url.size.toString());
      });
    form.append("min_image_count", (input.limitImage || 0).toString());
    input.stores && input.stores.forEach((store, index: number) => form.append(`stores[${index}]`, store));
    const response = await addNotice(form);
    return response;
  }

  async function sendModify(modifyNumber: string, input: ModifyApi) {
    const form = new FormData();
    input.imageList && input.imageList.forEach((image) => form.append("images", image as File));
    input.title && form.append("title", title);
    input.contents && form.append("contents", contents);
    input.currentCategory && form.append("cate_idx", input.currentCategory.toString());
    input.endDate && form.append("end_date", input.endDate);
    form.append("important_yn", input.important ? "Y" : "N");
    input.s3UrlList &&
      input.s3UrlList.forEach((url, index) => {
        form.append(`attachments[${index}][file_origin_name]`, url.originalFileName);
        form.append(`attachments[${index}][file_name]`, url.fileName);
        form.append(`attachments[${index}][file_url]`, url.path);
        form.append(`attachments[${index}][ext]`, url.ext);
        form.append(`attachments[${index}][size]`, url.size.toString());
      });
    input.deleteImgs &&
      input.deleteImgs.forEach((img, index) => {
        form.append(`delete_imgs[${index}]`, img);
      });
    input.deleteAttachments &&
      input.deleteAttachments.forEach((img, index) => {
        form.append(`delete_attachments[${index}]`, img);
      });
    form.append("min_image_count", (input.limitImage || 0).toString());
    const response = await modifyNotice({ notice_idx: modifyNumber, data: form });
    return response;
  }

  const ugc =
    "게시물 작성 시 아래 사항들을 준수해주시기 바랍니다.\n" +
    "\n" +
    " 1. 타인의 지적재산권을 침해하지 않습니다.\n" +
    " 2. 욕설, 비하, 차별, 성적인 언어, 폭력적인 내용을 포함하지 않습니다.\n" +
    " 3. 기타 법률, 규정, 제한 등을 준수합니다.\n" +
    "\n" +
    "UGC 작성 시 해당 사항을 준수하지 않을 경우, 법적인 책임을 질 수 있습니다. 또한, 본 서비스에서는 위반 사항이 확인되는 경우 해당 게시물를 삭제할 수 있습니다.";
  const userInfo = useAppSelector((state) => state.userReduce.userInfo);

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => back()}>
            공지
          </Button>
        </div>
        <div className="btn-box">
          {sending ? (
            <p style={{ textAlign: "center" }}>
              <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />
            </p>
          ) : (
            <Button variant="text" onClick={modifyMode ? () => modifyRegister(param.notice_idx!) : () => register()}>
              {modifyMode ? "수정" : "등록"}
            </Button>
          )}
        </div>
      </header>

      <Body type="detail">
        <NoticeRegisterBox>
          <ContentsBox>
            <Select options={category} defaultValue={currentCategory.toString()} onChange={onCategoryChange}></Select>
            <InputFileV2 className="input-file" imageList={imageList} setImageList={setImageList} />
            <TextInput
              id="d01"
              name="Title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder={"공지 제목을 입력해주세요."}
              maxLength={50}
            />
            <Editor
              placeholder={userInfo.user_id == "m1" ? ugc : ""}
              initialValue={contents}
              ref={editorRef}
              initialEditType={"wysiwyg"}
              height="400px"
              previewStyle={"vertical"}
              hideModeSwitch={true}
              onChange={handleChange}
              toolbarItems={[
                ["heading", "bold", "italic", "strike"],
                ["hr", "quote"],
                ["ul", "ol", "indent", "outdent"],
              ]}
              plugins={[colorSyntax]}
              useCommandShortcut={true}
            />
            <FileUpload />
          </ContentsBox>
          <List pd="0 16px" itemPd="16px 0">
            <WriteOptionItem />
          </List>
        </NoticeRegisterBox>
      </Body>
    </>
  );
}

const NoticeRegisterBox = styled.div`
  height: auto;
  min-height: 100%;
  > ul {
    border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
  }
`;

const ContentsBox = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("column", "flex-start", "stretch")}
  padding: 16px;
  > div {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .toastui-editor-defaultUI-toolbar {
    padding: 0 8px;
  }
  .toastui-editor-contents {
    padding: 16px;
    font-size: 16px;
  }
`;

export default noticeRegister;
